import { ThemeContext } from '../../../constants/themes';
import './index.css';

const Loader = (style) => {
   return (
      <ThemeContext.Consumer>
         {themeContext => (
            <div className="loaderwrapper" style={{...style}}>
               <span className="loader" style={{borderColor: themeContext.theme.text}}><span className="loader-inner" style={{backgroundColor: themeContext.theme.text}}></span></span>
            </div>
         )}
      </ThemeContext.Consumer>
   )
}

export default Loader;